import {FormControl, FormGroup, Validators} from "@angular/forms";
import {toString} from "../helpers/helpers";

export interface ContactModel {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  phoneNumber2?: string;
  emailAddress?: string;
  locale?: string;
}

export function contactModelFactory(json?: any): ContactModel {
  json = json || {};

  return {
    firstName: toString(json.firstName),
    lastName: toString(json.lastName),
    phoneNumber: toString(json.phoneNumber),
    phoneNumber2: toString(json.phoneNumber2),
    emailAddress: toString(json.emailAddress),
    locale: toString(json.locale),
  };
}

export function contactModelFormGroup(contact?: ContactModel): FormGroup {
  contact = contact || contactModelFactory();

  return new FormGroup({
    firstName: new FormControl(contact.firstName, [Validators.maxLength(40)]),
    lastName: new FormControl(contact.lastName, [Validators.maxLength(40)]),
    phoneNumber: new FormControl(contact.phoneNumber, [Validators.maxLength(40)]),
    phoneNumber2: new FormControl(contact.phoneNumber2, [Validators.maxLength(40)]),
    emailAddress: new FormControl(contact.emailAddress, [Validators.required, Validators.maxLength(100)]),
    locale: new FormControl(contact.locale, [Validators.maxLength(10)]),
  });
}
